import { gql } from '@apollo/client';
import { API_FIELDS_CONTACT as CONTACT, API_FIELDS_DEAL as DEAL } from '@enroller/admissions-components';
import { createStringPayload } from '../utils/formatSchema';

import type { FieldResponse } from '../graphqlResponse';

export const STUDENT_FIELDS = [
  CONTACT.ID,
  CONTACT.firstName,
  CONTACT.lastName,
  CONTACT.preferredName,
  CONTACT.gender,
  CONTACT.cityOfBirth,
  CONTACT.countryOfBirth,
  CONTACT.dateOfBirth,
  CONTACT.citizenship,
  CONTACT.residence,
  CONTACT.email,
  CONTACT.mobile,
  CONTACT.homePhone,
  CONTACT.emergencyContactRelation,
  CONTACT.emergencyContactPhoneNumber,
  CONTACT.emergencyContactName,
  CONTACT.country,
  CONTACT.city,
  CONTACT.postalCode,
  CONTACT.addressLine1,
  CONTACT.addressLine2,
];

const STUDENT_DEAL_FIELDS = [DEAL.ID, DEAL.programType];

export const STUDENT_DETAILS_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
          Student {
            ${createStringPayload(STUDENT_FIELDS)}
          }
          Deal {
            ${createStringPayload(STUDENT_DEAL_FIELDS)}
          }
        }
      }
    }
  }`;

export type StudentDetailsResponse = {
  Student: FieldResponse<typeof STUDENT_FIELDS>;
  Deal: FieldResponse<typeof STUDENT_DEAL_FIELDS>;
};
